document.addEventListener('DOMContentLoaded', function () {
  const dataEl = document.querySelector('[data-mfo-items]');
  const track = document.querySelector('[data-mfo-track]');
  if (!dataEl || !track) return;

  const base = JSON.parse(dataEl.textContent);
  const n = base.length;
  const REPS = 5;
  let items = [];
  for (let r = 0; r < REPS; r++) items = items.concat(base);
  let active = Math.floor(items.length / 2);
  active = active - (active % n);

  /* ===================== Slides are built ONCE and never torn down/rebuilt again — only
     their active state (a class toggle + swapping <img> for <video> and back) changes.
     Rebuilding the whole track's innerHTML on every click (the earlier approach) recreated
     every slide element from scratch each time, which is why the "always visible" video title
     used to visibly blink/flash on every interaction, not just when its own slide changed. */
  function buildSlide(it, i) {
    const el = document.createElement('div');
    el.className = 'mfo-slide' + (it.type === 'placeholder' ? ' is-placeholder' : '');
    el.dataset.i = String(i);
    if (it.type === 'placeholder') {
      const lines = it.name.split(' ').join('<br>');
      el.innerHTML = `<div class="media"><div class="mfo-placeholder-text">${lines}</div></div>`;
    } else {
      el.innerHTML = `<div class="mfo-video-title">${it.name}</div><div class="media"><img src="${it.img}" alt="${it.name} styling video"><div class="scrim-white"></div></div>`;
    }
    return el;
  }

  function setActiveState(i, isActive) {
    const el = track.children[i];
    if (!el) return;
    el.classList.toggle('is-active', isActive);
    const item = items[i];
    if (item.type === 'placeholder') return;

    const media = el.querySelector('.media');
    if (isActive) {
      const img = media.querySelector('img');
      if (img) {
        const video = document.createElement('video');
        video.src = item.video;
        video.poster = item.img;
        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        media.replaceChild(video, img);
        video.play().catch(() => {});
      }
    } else {
      const video = media.querySelector('video');
      if (video) {
        const img = document.createElement('img');
        img.src = item.img;
        img.alt = `${item.name} styling video`;
        media.replaceChild(img, video);
      }
    }
  }

  function centerActive() {
    const slide = track.children[active];
    if (!slide) return;
    const wrapW = track.parentElement.offsetWidth;
    const target = slide.offsetLeft - wrapW / 2 + slide.offsetWidth / 2;
    track.style.transform = `translateX(-${target}px)`;
  }

  function goToSlide(i) {
    if (i === active) return;
    setActiveState(active, false);
    active = i;
    setActiveState(active, true);
    centerActive();
    recenterIfNeeded();
  }

  function stepActive(dir) {
    goToSlide(active + dir);
  }

  function recenterIfNeeded() {
    const margin = n;
    if (active < margin || active > items.length - 1 - margin) {
      const cyclePos = active % n;
      const mid = Math.floor(items.length / 2);
      const newActive = mid - (mid % n) + cyclePos;
      if (newActive !== active) {
        setActiveState(active, false);
        active = newActive;
        setActiveState(active, true);
      }
      track.style.transition = 'none';
      centerActive();
      requestAnimationFrame(() => {
        track.style.transition = '';
      });
    }
  }

  // The section sits well below the fold, so its HD video slides are only built — and the
  // active one starts fetching/playing — once the section is about to scroll into view,
  // instead of the moment the page loads (this used to eagerly download and autoplay a
  // multi-megabyte 1080p video on every page load regardless of scroll position).
  function mount() {
    items.forEach((it, i) => track.appendChild(buildSlide(it, i)));
    setActiveState(active, true);
    centerActive();
  }

  const mfoSection = document.querySelector('.made-for-occasion-section');
  if (mfoSection && 'IntersectionObserver' in window) {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          mount();
          sectionObserver.disconnect();
        }
      },
      { rootMargin: '600px 0px' }
    );
    sectionObserver.observe(mfoSection);
  } else {
    mount();
  }

  track.addEventListener('click', (e) => {
    const slideEl = e.target.closest('.mfo-slide');
    if (!slideEl) return;
    const i = parseInt(slideEl.dataset.i, 10);
    const item = items[i];

    if (i !== active) {
      goToSlide(i);
      return;
    }

    // Already the centered/active slide: video slides enlarge in the shared lightbox; the
    // "more hairstyles" placeholder has no media to enlarge, so clicking it again does nothing.
    if (item.type === 'video' && window.SiscodeLightbox) {
      window.SiscodeLightbox.open({ type: 'video', video: item.video, img: item.img, label: item.name });
    }
  });

  window.addEventListener('resize', centerActive);

  /* Swipe left/right to step to the next/previous slide (touch devices only — mouse drag
     isn't handled, matching how the rest of the site treats desktop vs mobile). */
  const wrap = track.parentElement;
  let touchStartX = 0;
  let touchStartY = 0;
  let touchMoved = false;

  wrap.addEventListener(
    'touchstart',
    (e) => {
      const t = e.touches[0];
      touchStartX = t.clientX;
      touchStartY = t.clientY;
      touchMoved = false;
    },
    { passive: true }
  );

  wrap.addEventListener(
    'touchmove',
    () => {
      touchMoved = true;
    },
    { passive: true }
  );

  wrap.addEventListener(
    'touchend',
    (e) => {
      if (!touchMoved) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - touchStartX;
      const dy = t.clientY - touchStartY;
      const SWIPE_THRESHOLD = 40;
      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        stepActive(dx < 0 ? 1 : -1);
      }
    },
    { passive: true }
  );
});
